import { createAsyncThunk } from '@reduxjs/toolkit';
import { TimeHelper } from 'utils';

import { EVENT_STATS_FIND_ERROR } from '../types/calendarOverview';
import { apiClient } from '../../utils/CLIENT';

export const getEventStats = createAsyncThunk('eventStats/get', async (payload: {
  from: number;
  to: number;
  storeId: string;
  enterpriseId: string;
}, { getState }) => {
  const store = (getState() as any).store.data;
  const from = TimeHelper.unixToStandardFormat(payload.from, store.timezone);
  const to = TimeHelper.unixToStandardFormat(payload.to, store.timezone);

  const response = await apiClient.get('/lt-booking/event-stats', {
    params: {
      from,
      to,
      enterpriseId: payload.enterpriseId,
    },
  });

  if (!response || !response.data) {
    throw new Error(EVENT_STATS_FIND_ERROR);
  }

  return response.data;
});
